export default "__VITE_ASSET__YoO_6blD__"